import { Dimensions, } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles'

const isSmallDevice = Dimensions.get('window').width < 767

const useStyles = CreateResponsiveStyle(
  {
    mainContainerStyle: {
      height: Dimensions.get("window").height,
      width: "100%",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    proceedBtn:{ width: 108, height: 37, alignSelf: "center", marginTop: 30 },
    bodyContainerStyle: {
      flexDirection: "row",
      width: "100%",
      height: 'auto',
      flexWrap: "wrap",
    },
    bodyLeftViewStyle: {
      backgroundColor: "#f3f3f3",
      flex: 0.4,
      alignItems: "center",
      justifyContent: "center",
      paddingVertical: 25,
    },
    mobileComponentStyle: {
      position: "absolute",
      zIndex: 99,
      right: 15,
      left: 0,
      display: "none",
    },
    mobileContentWrapper:{
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 20,
        marginBottom: 10,
      
    },
    mobileContentWidget:{
      alignSelf: "center",
      justifyContent: "center",
      alignContent: "center",
    },
    footerContainerStyle: {
      marginTop: 0,
    },
    containerBox: {
      width: Dimensions.get('window').width < 768 ? 350 : 350,
      height: Dimensions.get('window').width < 768 ? 350 : 360,
      borderRadius: 15,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4
      },
      shadowRadius: 9,
      shadowOpacity: 1,
    },
    rectangle41: {
      width: "100%",
      height: 55,
      backgroundImage: "linear-gradient(to right, #f2717b 0%, #9d1d27 100%)",
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row"
    },
    loginTextStyle: {
      fontSize: 18.4,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 22.1,
      letterSpacing: 0,
      textAlign: "center",
      color: "#ffffff",
      justifyContent: "center"
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 20,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      paddingLeft: 10,
    },
    selectionContainerStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    },
    radiobuttonOutSideStyle: {
      width: 18,
      height: 18,
      borderRadius: 10,
      borderColor: "#9d1d27",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center"
    },
    radioButtonInsideStyle: {
      height: 10,
      width: 10,
      borderRadius: 7,
      backgroundColor: "#9d1d27"
    },
    chooseOptionStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0,
      textAlign: "left",
      color: "#797673",
      marginTop:20
    },
    
  },

  {
    [DEVICE_SIZES.LG]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3.2,
        flexWrap: "wrap",
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.4,
        alignItems: "center",
        justifyContent: "center",
      },
      mobileComponentStyle: {
        display: "none",
      },

    },
    [DEVICE_SIZES.MD]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
        marginTop: -20,
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.5,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      },
      mobileComponentStyle: {
        display: "none",
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainerStyle: {
        height: Dimensions.get("window").height,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
        backgroundColor: "red",
        marginTop: -20,
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.5,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      },
      mobileComponentStyle: {
        display: "none",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainerStyle: {
        height: 1100,
        minHeight: 850,
        maxHeight: 1100,
        width: "100%",
      },
      bodyContainerStyle: {
        flexDirection: "row",
        width: "100%",
        flex: 3,
        flexWrap: "wrap",
      },
      bodyLeftViewStyle: {
        backgroundColor: "#f3f3f3",
        flex: 0.45,
      },
      mobileComponentStyle: {
        display: "flex",
        backgroundColor: '#f3f3f3',
        width: '100%',
        paddingRight: 12
      },
      containerBox: {
        width: 330,
        height: 340,
        borderRadius: 15,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4
        },
        shadowRadius: 9,
        shadowOpacity: 1,
      },
      rectangle41: {
        width: "100%",
        height: 39,
        borderTopRightRadius: 15,
        borderTopLeftRadius: 15,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row"
      },
      loginTextStyle: {
        fontSize: 18.4,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 22.1,
        letterSpacing: 0,
        textAlign: "center",
        color: "#ffffff",
        justifyContent: "center"
      },
      textStyle: {
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 20,
        letterSpacing: 0,
        textAlign: "left",
        color: "#66625f",
        paddingLeft: 10,
      },
      selectionContainerStyle: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
      },
      radiobuttonOutSideStyle: {
        width: 18,
        height: 18,
        borderRadius: 10,
        borderColor: "#9d1d27",
        borderWidth: 2,
        alignItems: "center",
        justifyContent: "center"
      },
      radioButtonInsideStyle: {
        height: 10,
        width: 10,
        borderRadius: 7,
        backgroundColor: "#9d1d27"
      },
      chooseOptionStyle: {
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 17,
        letterSpacing: 0,
        textAlign: "left",
        color: "#797673"
      },
      footerContainerStyle: {
        marginTop: 800,
      },

    },
  }
);

export default useStyles;